<template>
  <section class="taxation-type">
    <el-row type="flex" align="middle">
      <el-select
        v-model="ndsStatus"
        class="taxation-type__select"
        placeholder="Выберите тип налогообложения"
      >
        <el-option
          v-for="item in taxationOptions"
          :key="item.value"
          :disabled="item.value === 'undefined'"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="warning" @click="onUpdate"> Сохранить тип </el-button>
    </el-row>
  </section>
</template>

<script>
import { taxationOptions } from './constants'

export default {
  name: 'TaxationType',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      taxationOptions,
    }
  },
  computed: {
    ndsStatus: {
      get() {
        return this.status || 'not_stated'
      },
      set(val) {
        this.$emit('set', val)
      },
    },
  },
  methods: {
    onUpdate() {
      this.$emit('save')
    },
  },
}
</script>

<style lang="sass">
.taxation-type
  &__select.el-select
    width: auto
    margin-right: 10px
</style>
